import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const CONSENT_KEY = "zirsen-cookie-consent";
const SID_KEY = "zirsen-sid";

let sid = sessionStorage.getItem(SID_KEY);
if (!sid) {
  sid = Math.random().toString(36).slice(2) + Date.now().toString(36);
  sessionStorage.setItem(SID_KEY, sid);
}

export const analyticsAllowed = () => {
  try {
    return JSON.parse(localStorage.getItem(CONSENT_KEY) || "{}").analytics === true;
  } catch {
    return false;
  }
};

export const track = (type, meta = {}) => {
  if (!analyticsAllowed()) return;
  axios
    .post(`${API}/analytics/event`, {
      type,
      path: window.location.pathname,
      sid,
      lang: localStorage.getItem("zirsen-lang") || "cs",
      meta,
    })
    .catch(() => {});
};
